import { getAuthTokenProp } from 'utils/auth/auth'
import { isOperations } from 'utils/auth/user'

function isSameUser (expectedUserId) {
  const realUserId = getAuthTokenProp('user_id')
  return realUserId === expectedUserId
}

export default function allowSameUserOrOperations (store) {
  return (nextState, replace, next, finish) => {
    const userId = parseInt(nextState.params.userId, 10)

    const allowed = isOperations() || isSameUser(userId)
    if (allowed) {
      return next()
    }

    // redirect non-authorized user
    replace('/')
    return finish()
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/allowSameUserOrOperations.js